// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zoraTestnet as _zoraTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zoraTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 999
 * Chain Name: Zora Goerli Testnet
 * Default Block Explorer: https://testnet.explorer.zora.energy
 * Default RPC URL: https://testnet.rpc.zora.energy
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zoraTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zoraTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zoraTestnet = createCommon({
	..._zoraTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
